<template>
	<nav class="bg-white shadow-sm">
		<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
			<div class="flex justify-between h-16">
				<!-- Left side -->
				<div class="flex">
					<!-- Logo/Home -->
					<RouterLink to="/admin" class="flex-shrink-0 flex items-center">
						<HomeIcon class="h-6 w-6 text-primary mr-2" />
						<span class="font-semibold text-xl">Admin Dashboard</span>
					</RouterLink>

					<!-- Navigation Links -->
					<div class="hidden sm:ml-6 sm:flex sm:space-x-8">
						<RouterLink
							v-for="link in navigationLinks"
							:key="link.to"
							:to="link.to"
							class="nav-link"
							:class="{
								'nav-link-active': $route.path.includes(link.to),
							}"
						>
							<component :is="link.icon" class="h-5 w-5 mr-1" />
							{{ link.text }}
						</RouterLink>
					</div>
				</div>

				<!-- Right side -->
				<AdminProfileDropdown />
			</div>
		</div>
	</nav>
</template>

<script setup>
import { RouterLink } from "vue-router";
import {
	HomeIcon,
	RocketLaunchIcon,
	BuildingStorefrontIcon,
	NewspaperIcon,
	DocumentTextIcon,
} from "@heroicons/vue/24/outline";

import AdminProfileDropdown from "@/components/layout/AdminProfileDropdown.vue";

const navigationLinks = [
	{ to: "/admin/hero", text: "Hero", icon: RocketLaunchIcon },
	{ to: "/admin/shops", text: "Shops", icon: BuildingStorefrontIcon },
	{ to: "/admin/news", text: "News", icon: NewspaperIcon },
	{ to: "/admin/articles", text: "Articles", icon: DocumentTextIcon },
	{ to: "/", text: "Home", icon: HomeIcon },
];
</script>

<style scoped>
.nav-link {
	@apply inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700;
}

.nav-link-active {
	@apply border-primary text-primary;
}
</style>
